<template>
  <div
    class="block-header header"
    :class="[device_platform, { header_scrolled: is_scrolled }]"
  >
    <div class="header__container container">
      <div class="header__logo-container">
        <img
          src="../images/logo/logo_black.svg"
          alt="Audi"
          class="header__logo"
        />
        <div class="header__dealer-name">
          <span>Ауди</span><br />
          Центр Север
        </div>
      </div>

      <img
        class="header__best-logo"
        src="../images/icons/best.png"
        alt="Лучший отдел продаж"
      />

      <v-phone
        v-if="device_platform === 'mobile'"
        :raw="CONSTANTS.phone_raw"
        class="header__phone"
      >
        <img src="../images/utils/phone.svg" alt="" />
      </v-phone>

      <div class="space"></div>

      <address class="header__address">
        {{ CONSTANTS.offices[0].address }}
      </address>

      <div class="space" v-if="device_platform === 'mobile'"></div>

      <p class="header__worktime">
        Ежедневно<br v-if="device_platform !== 'mobile'" />
        {{ CONSTANTS.worktime }}
      </p>

      <div class="header__phone-container" v-if="device_platform === 'desktop'">
        <v-phone :raw="CONSTANTS.phone_raw" class="header__phone">
          {{ CONSTANTS.phone }}
        </v-phone>
        <button
          class="header__btn"
          @click="
            getCall({ type: 'sale', form: 'header', title: 'Заказать звонок' })
          "
        >
          Заказать звонок
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import $ from "jquery";
import VPhone from "./v-phone.vue";

export default {
  name: "block-header",
  mixins: [Mixin],
  components: { VPhone },
  data() {
    return {
      is_scrolled: 0,
    };
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.show.creq = false;
      }
    });
    $(window).on("scroll", () => {
      this.is_scrolled = window.scrollY > 75;
    });
    this.is_scrolled = window.scrollY > 75;
  },
  methods: {
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.header {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  background-color: #fff;
  color: #000;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  transition: $transition;

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 15px;
    padding-bottom: 15px;
    transition: $transition;
  }

  &__logo-container {
    display: flex;
    align-items: center;
  }

  &__logo {
    margin-right: 13px;
  }

  &__best-logo {
    width: 230px;
  }

  &__dealer-name {
    font-size: 14px;
    font-family: "AudiTypeExt", sans-serif;
    font-weight: bold;

    span {
      color: $red;
    }
  }

  &__address {
    max-width: 200px;
    font-style: normal;
    position: relative;
    padding-left: 23px;

    &::before {
      content: url("../images/utils/location_black.svg");
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &__worktime {
    position: relative;
    padding-left: 23px;

    &::before {
      content: url("../images/utils/clock_black.svg");
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &__phone-container {
    display: flex;
    flex-direction: column;
  }

  &__btn {
    font-size: 15px;
    border: none;
    cursor: pointer;
    background-color: transparent;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 1000px) {
  .header {
    &__best-logo {
      display: none;
    }
  }
}

@media (max-width: 640px) {
  .header {
    &.header_scrolled {
      .header__address {
        display: none;
      }

      .header__worktime {
        display: none;
      }
    }

    &__container {
      flex-wrap: wrap;
      padding-top: 13px;
      padding-bottom: 17px;
    }

    &__address {
      max-width: 100%;
      margin: 23px 0 17px 0;
    }

    .space {
      width: 100%;
    }
  }
}
</style>
